import React from "react";
import { HeaderProps } from "../../../../../components/header/types";
import {Translate} from "../../../../../locales/locales-utils";

export const headerProps = (): HeaderProps => {
  return {
    // title: "Создавайте и проводите \n викторины на онлайн и \n оффлайн-мероприятиях",
    title: Translate("Index.Header.Title"),
    // description: (
    //     <span>Викторины до 500 одновременных игроков бесплатны. <br/> Если вам нужно больше игроков или <a href="/branding">брендированная <br/> версия</a>, напишите нам</span>
    // ),
    description: Translate("Index.Header.SubTitle"),
    button: [
      {
        text: Translate("Index.Header.Buttons.ButtonFirst"),
        variant: "primary",
        size: "lg",
        tag: "button"
      },
      {
        text: Translate("Index.Header.Buttons.ButtonSecond"),
        href: "/p/00687807",
        variant: "secondary",
        size: "lg",
        outlined: true
      },
    ],
    bubble: true,
    alignment: "flex-start",
    lang: "RU"
  }
}
